const getDeviceId = () => {
  let id = localStorage.getItem('deviceId');
  if (!id) {
    // The deviceId grants anonymous-vote attribution (and later adoption
    // into an account), so it must not be guessable. crypto.randomUUID is
    // available in every secure context we serve; the timestamp+Math.random
    // form remains only as a last-ditch fallback for ancient webviews.
    // Existing stored ids (either format) stay valid - the backend treats
    // the id as an opaque string.
    id = typeof crypto !== 'undefined' && crypto.randomUUID
      ? crypto.randomUUID()
      : `${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
    localStorage.setItem('deviceId', id);
  }
  return id;
};

export const getGuestAvatar = () => {
  const id = getDeviceId();
  let hash = 0;
  for (let i = 0; i < id.length; i += 1) {
    hash = (hash * 31 + id.charCodeAt(i)) % 1000000;
  }
  const avatarIndex = (hash % 24) + 1;
  return `/avatars/3d_avatar_${avatarIndex}.png`;
};

export default getDeviceId;
